import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../../components/tables/simpleTable';

import RecoverModal from '../../../components/modals/recoverModal';
import DeleteModal from '../../../components/modals/deleteModal';

import SearchFilter from '../../../components/filters/search';
import CustomButton from '../../../components/buttons/customButton';
import IsActiveFilter from '../../../components/filters/isActive';
import AddButton from '../../../components/buttons/addButton';
import DataFilter from '../../../components/filters/dataFilter';
import DatePicker from '../../../components/filters/datePicker';

import ViewModal from '../../../components/modals/viewModal';

import { FcKindle } from "react-icons/fc";

import Loader from '../../../components/loader/loader';
import { numberFormatter, trailBalanceFormatter } from '../../../components/formatters/numberFormatter';
import { dateFormatter } from '../../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter, statusTextFormatter } from '../../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter, FiFilter  } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { selectStyles } from '../../../components/dropDown/selectStyle';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules, FcViewDetails } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../../init/getData';




function NoAccount(props) {



  const { api, userData, settingData, refData, yearId, loadCustomerAccountOptions, customerAccountOptions,
    companyId, defaultCurrency, mainCurrency, allUserOptions, branchOptions, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);



  const type = ['salesInvoice', 'PosSale']


  const table = 'noAccount';
  const title = 'Sales By Invoice';

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today, type });


  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);




  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }


  const statusOptions = [
    { value: ['Paid'], label: 'Paid' },
    { value: ['UnPaid'], label: 'UnPaid' },
    { value: ['SemiPaid'], label: 'SemiPaid' },
    { value: ['SemiPaid', 'UnPaid'], label: 'UnPaid and SemiPaid' },
  ]

  //Excel Data
  const getExcelData = (data) => {
    const transformedData = data.map(item => ({
      ID: item.id,
      RefNumber: item.refNumber,
      CreatedAt: item.createdAt,
      Date: item.date,
      Type: item.type,
      Account: item.account?.english || '',
  
      Total: isUsingMainCurrency ? item.totalDebit : item.secondaryTotalDebit,
      Cost: isUsingMainCurrency ? item.cost : item.secondaryCost,
      Discount: isUsingMainCurrency ? item.discountAmount : item.secondaryDiscountAmount,
      Profit: isUsingMainCurrency ? item.profit : item.secondaryProfit,
  
      Status: statusTextFormatter(item.status),
      Details: item.details
    }));
  
    return { transformedData };
  };
  
  const isUsingMainCurrency = useMemo(() => defaultCurrency.id === mainCurrency.id, [defaultCurrency.id, mainCurrency.id]);

  const newColumnDefs = useMemo(() => [
    { title: contentLanguages.ID, dataIndex: 'id', width: '8%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.Date, dataIndex: 'date', width: '10%' },
    { title: contentLanguages.Type, dataIndex: 'type', width: '8%' },
    { title: contentLanguages.Account, dataIndex: 'account', render: (account) => (account?.english), width: '10%' },
    { title: contentLanguages.Total, dataIndex: isUsingMainCurrency ? 'totalDebit' : 'secondaryTotalDebit', width: '8%', render: numberFormatter },
    { title: contentLanguages.Cost, dataIndex: isUsingMainCurrency ? 'cost' : 'secondaryCost', width: '12%', render: numberFormatter },
    { title: contentLanguages.Discount, dataIndex: isUsingMainCurrency ? 'discountAmount' : 'secondaryDiscountAmount', width: '12%', render: numberFormatter },
    { title: contentLanguages.Profit, dataIndex: isUsingMainCurrency ? 'profit' : 'secondaryProfit', render: numberFormatter },
    { title: contentLanguages.Status, dataIndex: 'status', render: statusFormatter },
    {
      title: contentLanguages.View,
      width: '8%',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
        </div>
      ),
    }
  ], []);


  const tableFooter = (
    <div style={{ textAlign: 'center', paddingRight: '120px' }}>
    </div>
  )

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }


  const selectedBranch = useMemo(
    () => branchOptions?.find(option => option.value === filter.branchId),
    [branchOptions, filter.branchId]
  );

  const selectedUser = useMemo(
    () => allUserOptions?.find(option => option.value === filter.createdBy),
    [allUserOptions, filter.createdBy]
  );

  const selectedCustomer = useMemo(
    () => customerAccountOptions?.find(option => option.value === filter.accountId),
    [customerAccountOptions, filter.accountId]
  );

  const selectedStatus = useMemo(
    () => statusOptions?.find(option => option.value === filter.status),
    [statusOptions, filter.accountId]
  );

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>

          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={4}>
              <DatePicker setFilter={setFilter} filter={filter} />
                <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a'}}>
                  <FiFilter  size={15} color='white' />
                </Button>
            </Col>

            <Col md={4}>
            </Col>


            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
            </Col>

          </Row>



          <SimpleTable
            filter={filter}
            table={table}
            title={title}
            columnDefs={newColumnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
            height={true}
          />


          <ViewModal
            showModal={showViewModal}
            toggleModal={viewModal}
            journalVoucher={idRow}
          />



        </div>
      }


    </div>
  )
}

export default NoAccount;
